<template>
  <div>
    <section class="cabinet">
      <app-loading :is-loading="isLoading" />
      <div class="container-fluide">
        <div class="row">
          <div class="col-12">
            <div class="purchases__title-wrapper">
              <h2 class="purchases__subtitle">
                Партнёрская интернет-площадка Unistroy
              </h2>
              <PurchasesHeading heading="Актуальные закупки" />
            </div>
            <div class="purchases__list">
              <PageListTable>
                <template #before-table>
                  <colgroup>
                    <col width="5%">
                    <col width="5%">
                    <col width="7%">
                    <col width="33%">
                    <col width="14%">
                    <col width="18%">
                    <col width="8%">
                    <col width="1%">
                  </colgroup>
                </template>
              </PageListTable>
            </div>
            <Pagination
              v-if="pageCount > 1"
              :pages="pageCount"
              :current-page="page"
              :is-loading="isLoading"
              @clickPage="clickPage"
            />
          </div>
        </div>
      </div>

      <div
        v-if="showWarningBlock"
        class="cabinet-go-settings"
      >
        <div class="cabinet-go-settings__left">
          <p>
            Уважаемый пользователь!
          </p>
          <p>
            Обратите внимание, что у вас установлено ограничение на интересующие вас категории. Добавить или изменить категории можно в настройках Личного кабинета.
          </p>
        </div>
        <div class="cabinet-go-settings__right">
          <button
            class="search__button search__button--white"
            @click="settingsClicked"
          >
            <span class="search__link">Перейти в Настройки</span>
          </button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapState, mapActions } from 'vuex';
import { scrollToHeader } from '@/utils/helpers';

import loadListMixin from '@/mixins/loadListMixin';

import PurchasesHeading from '@/components/blocks/PageListHeading.vue';
import PageListTable from '@/components/blocks/PageListTable.vue';
import Pagination from '@/components/elements/Pagination.vue';

export default defineComponent({
  name: 'ActualPurchasesPage',
  components: {
    PurchasesHeading,
    PageListTable,
    Pagination,
  },
  computed: {
    ...mapState({
      pageCount: (state) => state.lots.list.pageCount,
      page: (state) => state.lots.list.page,
      lots: (state) => state.lots.list.lots,
      userCategories: (state) => state.user.categories,
      isLoading: (state) => state.lots.isLoading,
    }),
    // Показываем блок с призывом перейти в настройки
    showWarningBlock() {
      return !this.isLoading && !this.lots.length && this.userCategories.length < 5;
    },
  },
  methods: {
    ...mapActions('lots', ['setPage']),
    async clickPage(page) {
      await this.setPage(page);
    },
    settingsClicked() {
      this.$router.push({ name: 'UserSettings' });
    },
  },
});
</script>

<style lang="scss" scoped>
.cabinet-go-settings {
  display: grid;
  grid-template-columns: minmax(0, 680px) 350px;
  grid-column-gap: 30px;
  margin-top: 40px;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #161C21;
  align-items: center;

  & p {
    margin: 0;
    padding: 0;
  }

  & p + p {
    margin-top: 15px;
  }
}
</style>
